import { Component, OnInit, KeyValueDiffers, DoCheck, ViewContainerRef } from '@angular/core';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { DeviceBoardService } from "./device-board.service";
import { Router } from "@angular/router";

declare var $;

@Component({
  selector: 'app-device-board',
  templateUrl: './device-board.component.html',
  styleUrls: ['./device-board.component.css'],
  providers: [
    DeviceBoardService
  ]
})
export class DeviceBoardComponent implements OnInit {

  title: string;

  isLoading: boolean;
  filterParams: any;
  totalPage: number;
  deviceBoardList: any;
  deviceBoardInfo: any;
  totalElements: number;

  //watch variable change
  differ: any;
  constructor(
    private deviceBoardService: DeviceBoardService,
    private differs: KeyValueDiffers,
    private toastr: ToastsManager,
    private vcr: ViewContainerRef,
    private router: Router
  ) {
    this.toastr.setRootViewContainerRef(vcr);
    this.differ = this.differs.find({}).create();
  }

  ngOnInit() {
    this.title = "Device Board";
    this.filterParams = {
      size: 10,
      page: 0
    };
  }

  ngDoCheck() {
    var change = this.differ.diff(this.filterParams);
    if (change) {
      if (this.filterParams.page < 0) {
        this.filterParams.page = 0;
        return;
      } else if (this.filterParams.page > this.totalPage - 1) {
        this.filterParams.page = this.totalPage - 1;
        return;
      }
      this.getDeviceBoardList();
    }
  }

  getDeviceBoardList() {

    this.isLoading = true;
    this.deviceBoardService.getDeviceBoardList(this.filterParams)
      .then(res => {
        if( res.status === 1 )
        {
          this.deviceBoardList = res.data.dataList;
          this.totalElements = res.data.totalElements;
          this.initPaginate();
          this.isLoading = false;
        } else {
          this.toastr.error(res.message , 'Error!');
          if (res.errorCode === 3000) {
            localStorage.setItem("alert", JSON.stringify(res.message));
            this.router.navigate(['login']);
          }
        }
        
      })
      .catch(err => console.log(err));
  }

  //init paging 
  initPaginate() {
    this.totalPage = Math.ceil(this.totalElements / this.filterParams.size);
    let arrPagingNumber = [];
    for (let i = 0; i < this.totalPage; i++) {
      arrPagingNumber.push(i);
    }
    return arrPagingNumber;
  }

  editdeviceBoard(deviceBoard: any) {
    this.deviceBoardInfo = deviceBoard;
    $('#myModal').modal('show');
  }

  onSubmit(formDeviceBoard){
    this.deviceBoardService.editDeviceBoard(formDeviceBoard.value)
    .then( res => {
      console.log(res);
      if(res.status === 1) {
        this.getDeviceBoardList();
        $('#myModal').modal('hide');
      } else {
        this.toastr.error(res.message, "ERROR!");
        if (res.errorCode === 3000) {
          localStorage.setItem("alert", JSON.stringify(res.message));
          this.router.navigate(['login']);
        }
      }
    }).catch( err => console.log(err));
  }

}



// WEBPACK FOOTER //
// /build/client-cms/src/app/device-board/device-board.component.ts